import { useEffect, useState, useMemo } from "react";
import { Button, Card } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { FaSquareMinus } from "react-icons/fa6";
import { IoCheckbox } from "react-icons/io5";
import NavBar from "app/components-finmaq/nav-bar";
import { useGetContactWithProducts } from "app/carga-documentos/utilities/useGetContactWithProducts";
import textsByRole from "app/carga-documentos/utilities/textsByRole";
import { useParams } from 'react-router-dom';
import { Link } from "react-router-dom";
import FormFields, {FieldsProps} from "app/formulario-solicitud/utilities/formFields"; 
import classNameByEvent from "app/carga-documentos/utilities/classNameByEvent";
import HttpClientService from "http/httpClientService";
import { ConfigVariables } from "adapters/ports/config-variables";
import Modal from "app/components-finmaq/modal"; 
import useLegalChecks from "app/formulario-solicitud/utilities/useLegalChecks";
import { formatToClientTimezone } from "app/mis-creditos/utilities/formatToClientTimezone";
import { useCognitoUserAttributes } from 'app/login/adapters/useCognitoUserAttributes';
import { dotsFormat } from "app/utilities/dataFormatter";
import { handleTagManagerSteps } from "app/utilities/gtm";

export default function CargaDocumentos() {
    const [documentCondition, setDocumentCondition] = useState("empty");
    const [documentoFiscalCondition, setDocumentoFiscalCondition] = useState("empty");
    const [extractosCondition, setExtractosCondition] = useState("empty");
    const [infoMaquinaCondition, setInfoMaquinaCondition] = useState("empty");
    const [formCondition, setFormCondition] = useState("empty");
    const [documentStatus, setDocumentStatus] = useState("disable");
    const [isModalRadicadoOpen, setIsModalRadicadoOpen] = useState(false);
    const [hasErrorMessage, setHasErrorMessage] = useState(false);
    const [isProductDone, setIsProductDone] = useState(false);

    const { cognitoUUID, person_type, identity_type, identity_number } = useCognitoUserAttributes();
    const { contact, currentProduct, sortedProducts } = useGetContactWithProducts();
    const { productIndex } = useParams();
    const { isAllLegalChecked } = useLegalChecks(currentProduct);
    const productUUID = currentProduct["product_uuid" as keyof typeof currentProduct];
    const navigate = useNavigate();

    const formFieldsByType =  useMemo(()=>FormFields[person_type as keyof typeof FormFields] || [],[person_type]);
    const firstStep = useMemo(()=>formFieldsByType[0]?.inputs || [], [formFieldsByType])

    const identification_document_title = textsByRole[person_type as keyof typeof textsByRole]?.identification_document_title;
    const commercial_document_title = textsByRole[person_type as keyof typeof textsByRole]?.commercial_document_title;

    const financial_amount = (currentProduct as unknown as { financial_product: {
        financial_amount: number
    } }).financial_product?.financial_amount;

    const additional_income = (currentProduct as unknown as {
        finance: {
            additional_income: boolean
        }
    }).finance?.additional_income;

    const request_reason = (currentProduct as unknown as { financial_product: {
        request_reason: number
    } }).financial_product?.request_reason;

    const isFormInfoMaquinaCompleted = Boolean(typeof additional_income === "boolean" && request_reason);

    const created_at = (currentProduct as unknown as { created_at: string }).created_at;
    const {year: created_at_year = "", month: created_at_month = "", day: created_at_day = ""} = formatToClientTimezone(created_at) || {};

    const product_state = (currentProduct as unknown as { financial_product: {
        product_state: number
    } }).financial_product?.product_state;

    const completedSteps = [documentCondition, documentoFiscalCondition, extractosCondition, infoMaquinaCondition, formCondition].filter((status) => status === "completed").length;

    const currentDocuments = currentProduct["documents" as keyof typeof currentProduct];


    const handleSubmit = () => completedSteps === 5 && setIsModalRadicadoOpen(true);

    const handleRadicacion = ()=>{
        const productUUID = currentProduct["product_uuid" as keyof typeof currentProduct];

        const apiBaseUrl = ConfigVariables.URL_BASE_API;
        const endpoint = `${apiBaseUrl}client-profile/client/${person_type}_${identity_type}_${identity_number}`;
        
        const payload = {
            product:{
                product_id: productUUID,
                    "financial_product":{
                    "product_state":"RADICADO"
                }
            }
        };

        (async () => {
            setIsModalRadicadoOpen(false);
            try {
                await HttpClientService.patch<string>(endpoint,payload);
                setIsProductDone(true);

                handleTagManagerSteps({
                    action: "complete",
                    cognitoUserId: cognitoUUID,
                    productId: productUUID
                })
            } catch (error){
                console.log(error);
                setHasErrorMessage(true);
                setTimeout(()=>{
                    setHasErrorMessage(false);
                }, 15000);
            }
        })();
    }

    useEffect(()=>{    
        if(currentDocuments?.rut?.file_path || currentDocuments?.camara_comercio?.file_path) setDocumentoFiscalCondition("completed");
    
        if(currentDocuments?.identity_1?.file_path && currentDocuments?.identity_2?.file_path) setDocumentCondition("completed");
        if(currentDocuments?.identity_1?.file_path && !currentDocuments?.identity_2?.file_path) setDocumentCondition("incompleted");
        if(!currentDocuments?.identity_1?.file_path && currentDocuments?.identity_2?.file_path) setDocumentCondition("incompleted");
    
        if(currentDocuments?.extract_1?.file_path || currentDocuments?.extract_2?.file_path || currentDocuments?.extract_3?.file_path) setExtractosCondition("completed");
        
        if(isFormInfoMaquinaCompleted && currentDocuments?.quotation?.file_path) setInfoMaquinaCondition("completed");
        if(!isFormInfoMaquinaCompleted && currentDocuments?.quotation?.file_path) setInfoMaquinaCondition("incompleted");
        if(isFormInfoMaquinaCompleted && !currentDocuments?.quotation?.file_path) setInfoMaquinaCondition("incompleted");
        
        if(completedSteps === 5) setDocumentStatus("ready");
    },[currentDocuments, isFormInfoMaquinaCompleted, completedSteps])
    
    useEffect(()=>{
        const valuesFirstStep = firstStep.filter(({name, previousLock}:FieldsProps)=>{
            if(previousLock || !name) return false;
            return true
        }).map(({section, group, name}:FieldsProps)=> ({section, group, name}));
        
        const firstStepValuesCompleted = valuesFirstStep.filter((field)=>{
            const currentSection = contact[field.section as keyof typeof contact] || {};
            const currentGroup = currentSection[field.group as keyof typeof currentSection] || null;
            const currentValue = currentGroup ? currentGroup[field.name as keyof typeof currentGroup] : currentSection[field.name as keyof typeof currentSection];
            return currentValue !== undefined
        }).length;
        
        if(valuesFirstStep.length > 0 && firstStepValuesCompleted === valuesFirstStep.length && !isAllLegalChecked){
            setFormCondition("incompleted");
        }
        if(isAllLegalChecked) setFormCondition("completed");
    },[contact, firstStep, isAllLegalChecked])

    useEffect(()=>{
        if(cognitoUUID && productUUID) {
            handleTagManagerSteps({
                action: "enter",
                cognitoUserId: cognitoUUID,
                productId: productUUID
            })
        }
    },[cognitoUUID, productUUID])

    return (
        <div className={`w-full flex flex-col min-h-screen ${!currentDocuments ? `skeleton-animation` : ``}`}>
            <Modal
                className=""
                title=""
                message={<>¿Seguro que quiere <strong>enviar los documentos</strong> para radicar su solicitud?</>}
                imageUrl={ConfigVariables.IMAGEN_CONFIRMACION_DE_ENVIO}
                isOpen={isModalRadicadoOpen}
                primaryButtonLabel="Radicar Solicitud"
                secondaryButtonLabel="Cancelar"
                handlePrimaryButton={handleRadicacion}
                handleSecondaryButton={() => setIsModalRadicadoOpen(false)}
                handleCloseModal={() => setIsModalRadicadoOpen(false)} 
            />
            <form className="lg:flex flex-grow flex flex-col">
                <div className="mt-20 mb-[40px] block lg:flex justify-center flex-grow h-[calc(100vh-120px)] lg:h-auto">
                    <NavBar/>
                    <Card  placeholder={""} className="min-h-screen lg:min-h-screen w-full lg:ml-5 lg:mr-5 lg:mt-4 rounded-t-[20px] lg:rounded-t-3xl">
                        <div className="lg:flex block justify-between ml-6 mr-6 mt-[40px] lg:mt-[80px] lg:mr-[220px] lg:ml-[210px] lg:mt-[116px] lg:mr-[210px]">
                            <div className="relative">
                                {(sortedProducts && Object.keys(sortedProducts).length > 1) &&
                                    <Link to={`/mis-creditos`} className="inline-block relative lg:absolute left-[-5px] top-[8px] lg:left-[-40px] lg:top-[4px]">
                                        <svg className="text-[#390094]" width={32} height={32} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </Link>
                                }
                                <p className="inline-block text-[#390094] text-2xl lg:text-4xl font-bold lg:font-semibold lg:font-bold leading-10">Solicitud de crédito</p>
                                <p className="mt-[4px] text-[#718096] text-base lg:text-base skeleton-pulse"><span className="block sm:inline-block">INSSA</span><span className="hidden sm:inline"> - </span>${dotsFormat(financial_amount)} - {created_at_year}-{created_at_month}-{created_at_day}</p>
                                <p className="text-[#51C1E1] font-medium mt-6">Documentos requeridos</p>
                            </div>
                            {(product_state && (product_state.toString() !== "RADICADO" && !isProductDone)) &&
                                <p className="text-[#390094] text-2xl lg:text-3xl font-semibold right-0 text-end leading-10 mt-[15px] lg:mt-0 skeleton-opacity">{completedSteps}/5</p>
                            }
                        </div>
                        {(product_state && (product_state.toString() === "RADICADO" || isProductDone)) &&
                            <div className="ml-6 mr-6 lg:ml-[210px] lg:mr-[210px] bg-[#C6F6D5] flex items-center p-3 mt-3">
                                <svg className="w-[30px] h-[30px] mr-4" width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z" fill="#38A169"/>
                                </svg>
                                <div className="w-full">
                                    <strong className="text-[#000000]">Su solicitud se ha radicado correctamente</strong>
                                    <p className="text-[#000000]">¡Gracias por enviar su solicitud! Estamos revisando su información y pronto le informaremos el resultado a través de su correo electrónico.</p>
                                </div>
                            </div>
                        }
                        {hasErrorMessage &&
                            <div className="ml-6 mr-6 lg:ml-[210px] lg:mr-[210px] bg-[#FED7D7] flex items-center p-3 mt-3 relative">
                                <svg className="w-[30px] h-[30px] mr-4" width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z" fill="#E53E3E"/>
                                </svg>
                                <div className="w-[calc(100%-70px)]">
                                    <strong className="text-[#000000] mr-5 block">Su solicitud no se ha radicado correctamente</strong>
                                    <p className="text-[#000000]">Lo sentimos, hubo un problema al enviar su solicitud. Por favor, inténtelo de nuevo más tarde o contáctenos para obtener ayuda.</p>
                                </div>
                                <svg onClick={()=> setHasErrorMessage(false)} className="cursor-pointer absolute top-1/2 -translate-y-1/2 right-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18px" height="18px"><path d="M 4.9902344 3.9902344 A 1.0001 1.0001 0 0 0 4.2929688 5.7070312 L 10.585938 12 L 4.2929688 18.292969 A 1.0001 1.0001 0 1 0 5.7070312 19.707031 L 12 13.414062 L 18.292969 19.707031 A 1.0001 1.0001 0 1 0 19.707031 18.292969 L 13.414062 12 L 19.707031 5.7070312 A 1.0001 1.0001 0 0 0 18.980469 3.9902344 A 1.0001 1.0001 0 0 0 18.292969 4.2929688 L 12 10.585938 L 5.7070312 4.2929688 A 1.0001 1.0001 0 0 0 4.9902344 3.9902344 z" fill="#E53E3E"/></svg>
                            </div>
                        }
                        <div className={`mt-[15px] ml-6 mr-6 mb-[130px] lg:ml-[210px] lg:mr-[210px] ${product_state && (product_state.toString() === "RADICADO" || isProductDone) ? "pointer-events-none opacity-30" : ""}`}>
                            <button aria-label={`Botón ${identification_document_title}`} className="flex justify-between min-h-[50px] w-full border-b-2 text-[#000000] border-[#EAE5F3] p-3 items-center" onClick={()=> navigate(`/documento-identificacion/${productIndex}`)}>
                                <p className="text-md font-normal text-start pr-[10px] skeleton-pulse">{identification_document_title}</p> 
                                <div className="mr-3 mt-1">
                                    {documentCondition === "completed" &&
                                        <IoCheckbox color="#38A169" fontSize="1.5em" className="relative bottom-1 left-1"/> 
                                    }
                                    {documentCondition === "incompleted" &&
                                        <FaSquareMinus color="#F6AD55" fontSize="1.5em" className="relative bottom-1 left-1"/>
                                    }
                                    {documentCondition === "empty" &&
                                        <IoIosArrowForward className="skeleton-opacity"/>
                                    }
                                </div>
                            </button>
                            <button aria-label={`Botón ${commercial_document_title}`} className="flex justify-between min-h-[50px] w-full border-b-2 text-[#000000] border-[#EAE5F3] p-3 items-center" onClick={()=> navigate(`/documentos-fiscales/${productIndex}`)}>
                                <p className="text-md font-normal text-start pr-[10px] skeleton-pulse">{commercial_document_title}</p> 
                                <div className="mr-3 mt-1">
                                    {documentoFiscalCondition === "completed" &&
                                        <IoCheckbox color="#38A169" fontSize="1.5em" className="relative bottom-1 left-1"/> 
                                    }
                                    {documentoFiscalCondition === "empty" &&
                                        <IoIosArrowForward className="skeleton-opacity"/>
                                    }
                                </div>
                            </button>
                            <button aria-label={`Botón extractos bancarios`} className="flex justify-between min-h-[50px] w-full border-b-2 text-[#000000] border-[#EAE5F3] p-3 items-center" onClick={()=> navigate(`/extractos-bancarios/${productIndex}`)}>
                                <p className="text-md font-normal text-start pr-[10px] skeleton-pulse">Extractos bancarios</p> 
                                <div className="mr-3 mt-1">
                                    {extractosCondition === "completed" &&
                                        <IoCheckbox color="#38A169" fontSize="1.5em" className="relative bottom-1 left-1"/> 
                                    }
                                    {extractosCondition === "empty" &&
                                        <IoIosArrowForward className="skeleton-opacity"/>
                                    }
                                </div>
                            </button>
                            <button aria-label={`Botón Información de máquina`} className="flex justify-between min-h-[50px] w-full border-b-2 text-[#000000] border-[#EAE5F3] p-3 items-center" onClick={()=> navigate(`/informacion-maquina/${productIndex}`)}>
                                <p className="text-md font-normal text-start pr-[10px] skeleton-pulse">Información de la máquina</p> 
                                <div className="mr-3 mt-1">
                                    {infoMaquinaCondition === "completed" &&
                                        <IoCheckbox color="#38A169" fontSize="1.5em" className="relative bottom-1 left-1"/> 
                                    }
                                    {infoMaquinaCondition === "incompleted" &&
                                        <FaSquareMinus color="#F6AD55" fontSize="1.5em" className="relative bottom-1 left-1"/>
                                    }
                                    {infoMaquinaCondition === "empty" &&
                                        <IoIosArrowForward className="skeleton-opacity"/>
                                    }
                                </div>
                            </button>
                            <button aria-label={`Botón Formulario de solicitud`} className="flex justify-between min-h-[50px] w-full border-b-2 text-[#000000] border-[#EAE5F3] p-3 items-center" onClick={()=> navigate(`/formulario-solicitud/${productIndex}`)}>
                                <p className="text-md font-normal text-start pr-[10px] skeleton-pulse">Formulario de solicitud</p> 
                                <div className="mr-3 mt-1">
                                    {formCondition === "completed" &&
                                        <IoCheckbox color="#38A169" fontSize="1.5em" className="relative bottom-1 left-1"/> 
                                    }
                                    {formCondition === "incompleted" &&
                                        <FaSquareMinus color="#F6AD55" fontSize="1.5em" className="relative bottom-1 left-1"/>
                                    }
                                    {formCondition === "empty" &&
                                        <IoIosArrowForward className="skeleton-opacity"/>
                                    }
                                </div>
                            </button>
                        </div>
                        {(product_state && (product_state.toString() !== "RADICADO" && !isProductDone)) &&
                            <div className="fixed bottom-5 left-1/2 -translate-x-2/4 w-[90%] text-center">
                                <Button
                                    aria-label="Radicar Solicitud" 
                                    placeholder={""}
                                    className={`w-auto ${classNameByEvent(documentStatus)}  h-auto rounded-3xl text-md font-semibold normal-case lg:hidden relative w-5/6 max-w-[500px]`}
                                    onClick={handleSubmit}>
                                        Radicar Solicitud
                                </Button>
                            </div>
                        }
                    </Card>
                </div>
                <footer className="hidden lg:block z-50 fixed bottom-0 h-[70px] bg-gradient-to-b from-white via-[#E9EEF4] to-[#E9EEF4] w-full shadow-none border-2">
                    <div className='text-end h-full rounded-b-[24px] bg-white ml-[18px] mr-[18px] shadow-md'>
                        <div className='mr-[106px]'>
                            {(product_state && (product_state.toString() !== "RADICADO" && !isProductDone)) &&
                                <Button
                                    aria-label="Radicar Solicitud" 
                                    placeholder={""}
                                    className={`w-auto ${classNameByEvent(documentStatus)} mt-[8px] h-auto rounded-3xl text-md font-semibold normal-case`}
                                    onClick={handleSubmit}>
                                    Radicar Solicitud
                                </Button>
                            }
                        </div>
                    </div>
                </footer>
            </form>
        </div> 
    )
}